import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import FillButton from 'components/presenter/buttons/FillButton'
import cn from 'classnames'
import * as styles from './styles.module.css'

const HowItWorkSection = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className={cn(styles.sectionRoot)}>
        <iframe className={styles.videoRoot} title="dd" src="https://www.youtube.com/embed/5yKge-Pr_tY" frameBorder="0" />
        <div className={styles.designRoot}>
          <h3>
            {t('landing.howToDesign')}
          </h3>
          <span>{t('landing.howToDesignSubTitle')}</span>
          <div className={styles.contentRoot}>
            <p>{t('landing.designLeafletStep1')}</p>
            <p>{t('landing.designLeafletStep2')}</p>
            <p>{t('landing.designLeafletStep3')}</p>
            <p>{t('landing.designLeafletStep4')}</p>
          </div>
          <FillButton
            className={cn(styles.btnDesign, 'mui-btn-link')}>
            <a
              href="https://partner.canva.com/RybEv2"
              target="_blank"
            >
              {t('landing.freeDesign')}
            </a>
          </FillButton>
        </div>
      </div>
    </>
  )
}

export default HowItWorkSection